import BridgeController from "./bridge_controller";

export default class extends BridgeController {
  static values = { ...BridgeController.values, url: String }

  changeSubmit(event) {
    this.element.dataset.deviceSelected = event.currentTarget.value
  }

  async submit(event) {
    event.preventDefault();

    const formData = new FormData(this.element);
    const response = await fetch(this.urlValue, {
      method: "PATCH",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({
        template_id: formData.get("template_id"),
        device: formData.get("device")
      })
    });

    if (!response.ok) return;

    const { slot, path } = await response.json();

    this.send("vetomatic:mount", { slot, path, sizes: this.sizesValue[slot] });
    this.send("vetomatic:unmount", { slot: "prepare" });
  }
}
